module.exports = function() {
  return new Worker(__webpack_public_path__ + "54385cab407465d75764.worker.js");
};